import { render, staticRenderFns } from "./CorporativeDetails.vue?vue&type=template&id=04d2158a&scoped=true"
import script from "./CorporativeDetails.vue?vue&type=script&lang=js"
export * from "./CorporativeDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporativeDetails.vue?vue&type=style&index=0&id=04d2158a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d2158a",
  null
  
)

export default component.exports